import { useSearchParams } from 'react-router-dom'
import { projects } from './data/projectsArray'
import HighlightImageHandler from './HighlightImageHandler'
import HighlightTextHandler from './HighlightTextHandler'
import { Link } from 'react-router-dom'
import ResetScroll from './ResetScroll'
import { useEffect, useState} from 'react'
import HighlightModal from './HighlightModal'
import { Helmet } from 'react-helmet'

export default function Highlight({ translate }) {
  //Modal states:
  const [modalImage, setModalImage] = useState();
  const [modalText, setModalText] = useState();

  //Search Parameter states:
  const [searchParams] = useSearchParams();
  const parameter = searchParams.get('show')

  //Return Show Data
  const showData = projects.filter(project => {
    return project.code === parameter
  });

  //Get data from the database on a per-show basis
  const heroImage = showData[0].sourceSet
  const images = showData[0].images
  const name = showData[0].name
  const meta = showData[0].meta
  const heroAlt = showData[0].heroAlt
  const metaArray =showData[0].metaArray

  //This is in a seperate useEffect so that it only happens when the component mounts
  useEffect(() => translate(), [])// eslint-disable-line

  useEffect(() => { //This useEffect handles everything related to the image modal
    const previewImage = document.querySelectorAll('.showcase-image-container img')
    const modal = document.querySelector('.highlight-modal')
    const modalCloseButton = document.querySelector('.highlight-modal-close-btn')

    //Modal Functions:
    function openModal(image) {
      //Reveal the modal
      setModalImage(image.srcset)
      setModalText(image.dataset.desc)
      modal.classList.add('highlight-modal-visible')
      document.body.style.overflow='hidden'

      //Grayscale other images
      previewImage.forEach((otherImg) => {
        otherImg.classList.add('grayscale')
      })
  }

  function closeModal() {
    modal.classList.remove('highlight-modal-visible')
    document.body.style.overflow='auto'

    previewImage.forEach((otherImg) => {
      otherImg.classList.remove('grayscale')
    })
  }

  //Open Modal Events
  previewImage.forEach((image) => {
    image.addEventListener('pointerup', (e) => {
      if (e.button === 0) {openModal(image)}
    })

    image.addEventListener('keydown', (e) => {
      if(e.isComposing || e.keyCode === 13) {openModal(image)}
    })
  })

  //Close Modal Events
  modal.addEventListener('pointerup', (e) => {
    if (e.button === 0) {closeModal()}
  })

  modalCloseButton.addEventListener('keydown', (e) => {
    if (e.code === "Enter") {closeModal()}
  })

  })//Use Effect Close Brackets

  return (
  <div className='highlight-container container'>

    <Helmet>
      <title>{name} - Chris Milburn Lighting Design</title>
    </Helmet>

      <div className='highlight-hero'>
        <div className='imgOverlay'></div>
        <h2 className='heroText'>{name}</h2>
        <div className='hero-image-container'><img srcSet={heroImage} alt={heroAlt} /></div>
      </div>
        {meta ? <div className='highlight-meta'>{meta}</div> : null}
        {metaArray ? <div className='highlight-meta'>{metaArray.map(line => (<HighlightTextHandler key={line.key} title={line.title} text={line.text} format={line.format} i18nKeyTitle={line.i18nKeyTitle} i18nKeyText={line.i18nKeyText}/> ))}</div> : null}
      <div className='showcase'>
        {images.map(image => (<HighlightImageHandler key={image.key} altText={image.alt} src={image.sourceset} photographer={image.photographer} gridcols={image.gridcols} gridrows={image.gridrows} desc={image.desc}/>))}
    </div>
    <div className='grid-col-span-3 return-link-container'><Link onClick={ResetScroll} className='return-home-link' to='/'><span data-i18n-key='return-to-projects'>Return to Projects</span></Link></div>
    

  <HighlightModal modalImage={modalImage} modalText={modalText}/>
    
  </div>
  )
}
